import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'app/shared/authentication/authentication.service';
import { ChangePassword } from 'app/shared/models/change-password.model';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  password: ChangePassword;
  protected changePasswordMessage: string;

  constructor(private authenticationService: AuthenticationService, private router: Router, protected translateService: TranslateService) {
  }

  ngOnInit() {
    this.initializeObject();
    this.translateService.get(['account.changePassword.changePasswordMessage'])
      .subscribe(translations => {
        this.changePasswordMessage = translations['account.changePassword.changePasswordMessage'];
      });
  }

  initializeObject() {
    if (this.password == null) {
      this.password = new ChangePassword();
    }
  }

  onSubmit(form: NgForm) {
    this.authenticationService.changePassword(form.value, () => this.authenticationService.logout(), this.changePasswordMessage);
  }
}
